import { getEndDate, getShowTimeZone, getStartDate, isDateTbd, isEndDateHidden, isEventV3, isScheduled, isStarted, } from '@wix/wix-events-commons-statics';
import { getDurationInHours, getMomentDate, now } from './date';
import { formatDates, getFullDate, getShortDate, getTime, isYearHidden } from './formatter';
export const getFormattedStartDate = (event, fullLocale, forceShowYear = false) => {
    const scheduleTbdMessage = isEventV3(event)
        ? event.dateAndTimeSettings.dateAndTimeTbdMessage
        : event.scheduling.config.scheduleTbdMessage;
    const startDate = getStartDate(event);
    const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
    const showTimeZone = getShowTimeZone(event);
    if (isDateTbd(event)) {
        return scheduleTbdMessage;
    }
    const showYear = forceShowYear || !isYearHidden(getMomentDate(startDate, timeZoneId));
    return getFullDate(startDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const getFormattedShortStartDate = (event, fullLocale) => {
    const scheduleTbdMessage = isEventV3(event)
        ? event.dateAndTimeSettings.dateAndTimeTbdMessage
        : event.scheduling.config.scheduleTbdMessage;
    const startDate = getStartDate(event);
    const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
    if (isDateTbd(event)) {
        return scheduleTbdMessage;
    }
    return getShortDate(startDate, timeZoneId, fullLocale);
};
export const getFormattedStartTime = (event, fullLocale) => {
    const startDate = getStartDate(event);
    const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
    return getTime(startDate, timeZoneId, fullLocale);
};
export const getFormattedFullDate = (event, fullLocale, showYear = false) => {
    const scheduleTbdMessage = isEventV3(event)
        ? event.dateAndTimeSettings.dateAndTimeTbdMessage
        : event.scheduling.config.scheduleTbdMessage;
    const endDateHidden = isEndDateHidden(event);
    const startDate = getStartDate(event);
    const endDate = getEndDate(event);
    const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
    const showTimeZone = getShowTimeZone(event);
    return isDateTbd(event)
        ? scheduleTbdMessage
        : formatDates(startDate, endDateHidden ? null : endDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const getDaysToEvent = (event) => {
    let days = 0;
    const HOURS_PER_DAY = 24;
    if (!isDateTbd(event)) {
        const startDate = getStartDate(event);
        const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
        const start = getMomentDate(startDate, timeZoneId);
        const hours = getDurationInHours(start, now(timeZoneId));
        days = Math.ceil((hours - start.hour()) / HOURS_PER_DAY);
    }
    return Math.max(days, 0);
};
export const getFormattedOpeningClosureDate = (date, fullLocale, showTimeZone, timeZoneId, forceShowYear = false) => {
    const showYear = forceShowYear || !isYearHidden(getMomentDate(date, timeZoneId));
    return getFullDate(date, timeZoneId, showYear, fullLocale, showTimeZone);
};
export const isHappeningToday = (event) => {
    if (isScheduled(event)) {
        if (!isDateTbd(event)) {
            const startDate = getStartDate(event);
            const timeZoneId = isEventV3(event) ? event.dateAndTimeSettings.timeZoneId : event.scheduling.config.timeZoneId;
            const start = getMomentDate(startDate, timeZoneId);
            const currentTime = now(timeZoneId);
            if (start.isSame(currentTime, 'date')) {
                return true;
            }
        }
    }
    return isStarted(event);
};
//# sourceMappingURL=event-selectors.js.map